export default {"src":"/_next/static/media/done.c3cf0807.svg","height":224,"width":215,"blurWidth":0,"blurHeight":0};